module.exports = __webpack_public_path__ + "static/media/t2.cb1e2f35.png";